import { ref } from 'vue'

export const useIntroduceSection = () => {
  const { analyticEvent, fbPixelEvent } = useAnalytic()
  const showVideoModal = ref<boolean>(false)

  const eventHomeButton = (link: string, name: string) => {
    analyticEvent({
      ga4ActionName: 'click_introduce_btn_home',
      ga4Label: link,
    })
    fbPixelEvent({ fbEvent: `Click - ${name}` })
  }

  const showVideo = (link: string, name: string) => {
    showVideoModal.value = true
    eventHomeButton(link, name)
  }

  return {
    showVideoModal,
    showVideo,
    eventHomeButton,
  }
}
